var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings-external-plugins" }, [
    _vm.plugins.length > 0
      ? _c(
          "ul",
          { staticClass: "settings-external-plugins__list" },
          _vm._l(_vm.sortedPlugins, function(plugin, indexPlugin) {
            return _c(
              "li",
              {
                key: indexPlugin,
                staticClass: "settings-external-plugins__list-item"
              },
              [
                _c(
                  "a",
                  { attrs: { href: plugin.url, onClick: plugin.call } },
                  [
                    plugin.isSlsyIcon
                      ? _c("CompassIcon", {
                          staticClass: "compassIcon",
                          attrs: {
                            customFile: _vm.pathSlsyIcon(plugin.iconSvg),
                            customIcon: plugin.iconSvg
                          }
                        })
                      : _c("SaasIcon", {
                          attrs: {
                            height: "40",
                            width: "40",
                            icon: plugin.iconSvg
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [_vm._v(_vm._s(plugin.label))]
                    )
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      : _c("div", { staticClass: "placeholder" }, [
          _c("p", [
            _vm._v(_vm._s(_vm.$l10n.__("Vous n'avez pas de module externe")))
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }